export default function KissPush(arr) {
    window._kmq = window._kmq || [];
    window._kmq.push(arr);
}
